module.exports = __webpack_public_path__ + "img/ios.0f5e188c.svg";